module.exports = __webpack_public_path__ + "img/quiz.4b2681c2.png";